import { Dispatch, SetStateAction } from 'react';
import { RecordInterface } from '@type/form-types';
import { Input } from '@components/common/Forms';
import { Chip } from '@components/common';

// Interfaces
// **************************************
interface TopBarSingleProps {
  setFormValues?: Dispatch<SetStateAction<object>>,
  submitFunc?: () => void,
  recordFunc: RecordInterface,
  filterName: string,
  filterLabel?: string,
  secondaryFilterName?: string,
  idPrefix?: string,
  primaryValue?: string | number,
  secondaryValue?: string | number,
}


/**
 * @description The top bar single filter component.
 * ***setFormValues** - the function to set the form values. Defaults to undefined.
 * ***submitFunc** - the function to trigger the form submit. Defaults to undefined.
 * ***recordFunc** - the record function from useBjForm.
 * ***filterName** - the name of the filter.
 * ***filterLabel** - the label of the filter. Defaults to an empty string. It will be the text displayed in the pill.
 * ***secondaryFilterName** - the name of the secondary filter. Defaults to undefined. Use it when you need to clear
 * a secondary filter when clearing the main filter (ie: location and radiusInKm).
 * ***idPrefix** - the prefix for the form elements ids. When using multiple forms on the same page,
 * this is needed to avoid duplicate ids. Defaults to an empty string.
 * ***primaryValue** - the default value for the primary filter. Defaults to an empty string.
 * ***secondaryValue** - the default value for the secondary filter. Defaults to an empty string.
 */
export const TopBarSingle = (props: TopBarSingleProps) => {
  // Destructure props
  const {
    setFormValues,
    submitFunc,
    filterName,
    filterLabel = '',
    secondaryFilterName,
    recordFunc,
    primaryValue = '',
    secondaryValue = '',
    idPrefix = '',
  } = props;


  // Handle the filter clear
  // **************************************
  const clearFilter = () => {
    if (setFormValues) setFormValues({ [filterName]: '', [secondaryFilterName || '']: '' });
    if (submitFunc) setTimeout(() => submitFunc(), 50);
  };


  // Render component
  // **************************************
  return (
    <Chip onDelete={clearFilter}>
      {/* Hidden value holders */}
      <Input type="hidden" {...recordFunc(filterName, { id: `${idPrefix}${filterName}`, defaultValue: primaryValue })} />
      {secondaryFilterName && <Input type="hidden" {...recordFunc(secondaryFilterName, { id: `${idPrefix}${secondaryFilterName}`, defaultValue: secondaryValue })} />}


      {/* Filter label */}
      {filterLabel}
    </Chip>
  );
};
